import { WorkspaceServiceService } from './../../services/workspace-service.service';
import { Component, OnInit, OnDestroy, Input, HostBinding, ElementRef, HostListener } from '@angular/core';
import { MenuItem } from './menu-item';
import { Button } from './button';
import { WolfieContextMenuService } from '../../services/wolfie-context-menu/wolfie-context-menu.service';
import { Subscription } from 'rxjs';


//TODO: component should be divided into three components: context-menu, menu-item, button
//TODO: for more than 1 button, we need to set dynamic margin right on menu-item > name
@Component({
  selector: 'wolfie-context-menu',
  template: require('./wolfie-context-menu.component.html'),
  styles: [require('./wolfie-context-menu.component.scss')]
})
export class WolfieContextMenuComponent implements OnInit, OnDestroy
{
  @Input()
  x = '100%';

  @Input()
  y = '0';

  @Input()
  items: MenuItem[] = [];

  @Input()
  parentItem?: MenuItem;

  private inversedX = false;
  private inversedY = false;
  private shiftY = 0;

  // dirty, but simple checking for viewport fitness
  get inverseX()
  {
    if(this.inversedX)
      return true;
    //@ts-ignore
    return this.inversedX = this.elementRef.nativeElement.getBoundingClientRect().right > (window.innerWidth || document.documentElement.clientWidth);
  }

  @HostBinding('style.left')
  get left()
  {
    return this.inversedX? undefined: this.x;
  }

  @HostBinding('style.top')
  get top()
  {
    return this.y;
  }

  @HostBinding('style.right')
  get right()
  {
    return !this.inversedX? undefined: this.x;
  }

  @HostBinding('style.transform')
  get transform(): string | undefined
  {
    return 'translateY(-' + this.shiftY + 'px)';
  }

  @HostBinding('class.menu-element')
  protected readonly isMenuElement = true;

  protected checkScreenFitInterval: number | null = null;

  @Input()
  showAfterTimeMs?: number = 300;

  constructor(protected elementRef: ElementRef, protected contextMenuService: WolfieContextMenuService, protected workspaceService: WorkspaceServiceService) 
  {
    this.checkScreenFitInterval = setInterval(() =>
    {
      var diffY = this.elementRef.nativeElement.getBoundingClientRect().bottom - ((<any>window).innerHeight || (<any>document).documentElement.clientHeight);
      if(Math.abs(diffY) > 5)
        this.shiftY = Math.max(0, this.shiftY + diffY);

        this.inversedX = this.elementRef.nativeElement.getBoundingClientRect().right+(this.inversedX?this.elementRef.nativeElement.getBoundingClientRect().width+this.elementRef.nativeElement.parentElement.getBoundingClientRect().width: 0) > ((<any>window).innerWidth || (<any>document).documentElement.clientWidth)
    }, 100) as any as number;
  }

  public getIconStyle(item: MenuItem)
  {
    return Object.assign({'min-height': this.contextMenuService.iconSize + 'px', 'min-width': this.contextMenuService.iconSize+ 'px'}, item.iconNgStyle || {})
  }

  ngOnInit() 
  {
  }

  ngOnDestroy ()
  { 
    this.clearCheckScreenFitInterval();
  }

  clearCheckScreenFitInterval()
  {
    if(this.checkScreenFitInterval != null) 
    {
      clearInterval(this.checkScreenFitInterval);
      this.checkScreenFitInterval = null;
    }
  }
  itemAction(item: MenuItem, event: MouseEvent)
  {
    event.stopPropagation();
    if(item.callback != undefined) 
    {
      if(item.callback() == true)
        return;
      this.contextMenuService.hide();
    }
  }

  buttonAction(button: Button, event: MouseEvent)
  {
    event.stopPropagation();
    this.contextMenuService.hide();
    if(button.callback != undefined) button.callback();
  }

  mouseStoppedTimeout?: number;
  lastHoveredItem: any = null;
  @HostListener('mousemove', ['$event'])
  mouseMove(event: MouseEvent)
  {
    if(this.mouseStoppedTimeout != undefined && Math.abs(event.movementX) + Math.abs(event.movementY) > 1)
    {
      clearInterval(this.mouseStoppedTimeout);
      this.mouseStoppedTimeout = undefined;
    }
    if(this.mouseStoppedTimeout == undefined) this.mouseStoppedTimeout = setTimeout(() => this.mouseStopped(), 100) as any as number;
  }

  mouseStopped()
  {
    if(this.lastHoveredItem != null)
    {
      const item = this.lastHoveredItem;
      const parentNode = item.parentNode;
      if(parentNode != undefined)
      {
        parentNode.childNodes.forEach((n: any) => {if(n.nodeType == 1) n.classList.remove('open'); });
        item.classList.add('open');
      }
    }
  }

  itemMouseEnter(event: MouseEvent)
  {
    let item: any = event.currentTarget;
    /*item.showTimeout = setTimeout(() =>
    {
      item.parentNode.childNodes.forEach((n: any) => {if(n.nodeType == 1) n.classList.remove('open'); });
      if(item.hideTimeout != null)
      {
        clearTimeout(item.hideTimeout);
        item.hideTimeout = null;
      }
      item.classList.add('open');
    }, 500);*/
    if(item.hideTimeout != null)
    {
      clearTimeout(item.hideTimeout);
      item.hideTimeout = null;
    }
    this.lastHoveredItem = item;
  }

  /*itemMouseLeave(event: MouseEvent)
  {
    let item: any = event.currentTarget;
    if(item.showTimeout != null)
    {
      clearTimeout(item.showTimeout);
      item.showTimeout = null;
    }
    item.hideTimeout = setTimeout(() => {item.classList.remove('open'); item.hideTimeout = null;}, 200);
  }*/
}
